import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';

import TooltipComponent from './TooltipComponent';


const Tooltip = ({ text, className = '' }) => (
  <TooltipComponent
    name={`tooltip-${uuid().slice(0, 8)}`}
    text={text}
    className={className}
  />
);

Tooltip.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default Tooltip;
